import React from 'react';
import { Settings } from 'lucide-react';

const ServiceCard = ({ service }) => {
  // Icon mapping - Admin panelinden gelen Lucide icon isimlerini emoji'lere çevir
  const iconMap = {
    // Lucide icon isimleri -> Emoji
    'Settings': '⚙️',
    'Flame': '🔥',
    'Wrench': '🔧',
    'Zap': '⚡',
    'Droplets': '💧',
    'Home': '🏠',
    'Building': '🏢',
    'Hammer': '🔨',
    'Cog': '⚙️',
    'Shield': '🛡️',
    'Heart': '❤️',
    'Target': '🎯',
    'Award': '🏆',
    'Lightbulb': '💡',
    'Circle': '⭕',
    'Square': '⬜',
    'Triangle': '🔺',
    // Eski FontAwesome mapping'i de koru (geriye uyumluluk için)
    'fa-fire': '🔥',
    'fa-cog': '⚙️',
    'fa-wrench': '🔧',
    'fa-shield': '🛡️',
    'fa-building': '🏢',
    'fa-home': '🏠',
    'fa-droplet': '💧',
    'fa-snowflake': '❄️',
    'fa-bolt': '⚡',
    'default': '⚙️'
  };

  const getIcon = (iconName) => {
    return iconMap[iconName] || iconMap['default'];
  };

  return (
    <div className="group bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border relative">
      {/* Öne Çıkan Etiketi */}
      {service.is_featured && (
        <div className="absolute top-2 right-2 z-10">
          <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-xs font-medium rounded-full flex items-center gap-1">
            ⭐ Öne Çıkan
          </span>
        </div>
      )}
      
      <div className="p-6 text-center">
        {/* İkon */}
        <div className="mx-auto bg-blue-100 group-hover:bg-blue-600 transition-colors duration-300 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-4">
          <span className="text-2xl">{getIcon(service.icon)}</span>
        </div>
        
        {/* Başlık */}
        <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
        
        {/* Açıklama */}
        <p className="text-gray-600 mb-4">{service.description}</p>

        {/* Detaylar */}
        {service.details && service.details.length > 0 && (
          <ul className="space-y-2 mb-6">
            {service.details.slice(0, 2).map((detail, idx) => (
              <li key={idx} className="flex items-center justify-center text-sm text-gray-600">
                <div className={`w-2 h-2 rounded-full mr-3 ${
                  detail.includes('Güvenli') || detail.includes('Garanti') 
                    ? 'bg-red-600' : 'bg-blue-600'
                }`}></div>
                <span className={
                  detail.includes('Güvenli') || detail.includes('Garanti')
                    ? 'text-red-700 font-medium' : ''
                }>
                  {detail}
                </span>
              </li>
            ))}
          </ul>
        )}

        {/* Etiketler */}
        {service.tags && service.tags.length > 0 && (
          <div className="mb-6">
            <div className="flex flex-wrap justify-center gap-2">
              {service.tags.map((tag, idx) => (
                <span 
                  key={idx} 
                  className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Alt Kısım */}
        <div className="pt-4 border-t">
          <div className="flex items-center justify-center mb-4">
            <p className="text-blue-600 font-semibold">
              {service.price_start ? `${service.price_start}₺'den başlayan fiyatlar` : 'Proje bazında fiyatlandırma'}
            </p>
          </div>
          <a 
            href="/iletisim" 
            className="block w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-200 text-center"
          >
            Detaylı Bilgi Al
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;